import { atom } from 'jotai';

export const chatGalleryAtom = atom<{ images: string[]; title: string } | null>(
  null,
);
